import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { getUserDetails, getUserRoleType } from '../../../services/aws/aws-services';
import { definedRoutesForRoles, MenuPageNames, RoutesSlugs } from '../../../constants/definedRoutes/definedRoutes';

export default class ActiveDirectoryUserComponent extends Component {
    render() {
        const userDetails = getUserDetails();
        const loggedInUserType = getUserRoleType();
        const { handleLogout } = this.props;

        var redirectPage = RoutesSlugs.systemLogs;
        if (definedRoutesForRoles[loggedInUserType]?.length && definedRoutesForRoles[loggedInUserType].indexOf(RoutesSlugs.devices.list) > -1) {
            redirectPage = RoutesSlugs.devices.list
        }
        
        return (
            <div className="data-list-tabs dashboard-blocks p-4">
                <h1 className="my-4 text-muted">Welcome {userDetails ? `${userDetails.given_name} ${userDetails.family_name}` : 'user'}</h1>
                <div className="mt-3">
                    <Link className="btn btn-primary my-2 me-2" to={{ pathname: redirectPage }}>View {MenuPageNames[redirectPage]}</Link>
                    <button className="btn btn-secondary my-2" type="button" onClick={handleLogout}>Log out</button>
                </div>
            </div>
        )
    }
}
